import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
};
export function Button({
  children,
  href = 'https://go.hotmart.com/W104285887H?dp=1',
  className = ''
}: ButtonProps) {
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02,
    boxShadow: '0 0 20px rgba(201, 168, 76, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} className={`inline-block bg-gold text-navy font-semibold px-8 py-4 rounded-full text-lg transition-colors hover:bg-[#d4b45a] cursor-pointer ${className}`} data-id="element-185">
      {children}
    </motion.a>;
}